"use client"

import { useState, useEffect, useCallback } from "react"
import { isScrollToTopVisible } from "@/lib/scrollFabVisibility"
import { usePromotionBannerOpen } from "@/lib/promotionBannerOpenStore"

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false)
  const isPromotionBannerOpen = usePromotionBannerOpen()

  useEffect(() => {
    let ticking = false
    const onScroll = () => {
      if (!ticking) {
        const y = window.scrollY
        requestAnimationFrame(() => {
          setVisible(isScrollToTopVisible(y))
          ticking = false
        })
        ticking = true
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setVisible(isScrollToTopVisible())
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [])

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      data-promotion-banner-open={isPromotionBannerOpen}
      className={`scroll-to-top fixed left-6 z-20 flex h-8 w-8 items-center justify-center rounded-full bg-gray-m2 text-white shadow-lg transition-[opacity,bottom,transform] duration-300 ease-in-out hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-trmb focus-visible:ring-offset-2 cursor-pointer ${visible ? "opacity-100" : "pointer-events-none opacity-0"} ${isPromotionBannerOpen ? "bottom-[calc(var(--promotion-banner-height,0px)+1.5rem)]" : "bottom-6"}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="#252A2E">
        <path d="M8.83046 3.88244L5.24046 0.292444C5.14794 0.19974 5.03805 0.126193 4.91708 0.0760114C4.79611 0.02583 4.66643 0 4.53546 0C4.40449 0 4.27481 0.02583 4.15383 0.0760114C4.03286 0.126193 3.92297 0.19974 3.83046 0.292444L0.240457 3.88244C0.0766307 4.07375 -0.00897537 4.31982 0.000745782 4.5715C0.0104669 4.82317 0.114799 5.06191 0.292894 5.24001C0.470988 5.4181 0.709728 5.52243 0.961404 5.53216C1.21308 5.54188 1.45916 5.45627 1.65046 5.29244L3.53046 3.41244H3.54046V15.0024C3.54046 15.5524 3.99046 16.0024 4.54046 16.0024C5.09046 16.0024 5.54046 15.5524 5.54046 15.0024V3.41244L7.42046 5.29244C7.61176 5.45627 7.85784 5.54188 8.10951 5.53216C8.36119 5.52243 8.59993 5.4181 8.77802 5.24001C8.95612 5.06191 9.06045 4.82317 9.07017 4.5715C9.07989 4.31982 8.99428 4.07375 8.83046 3.88244Z" fill="#252A2E"/>
      </svg>
    </button>
  )
}
